// extracted by css-extract-rspack-plugin
export default {"module-modal-content":"module-modal-content-kinqTq","moduleModalContent":"module-modal-content-kinqTq"};